/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PractitionerLeaveDelete$Params {
  lobbyId?: string;
}

export function practitionerLeaveDelete(http: HttpClient, rootUrl: string, params?: PractitionerLeaveDelete$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, practitionerLeaveDelete.PATH, 'delete');
  if (params) {
    rb.query('lobbyId', params.lobbyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as ACSStrictHttpResponse<void>;
    })
  );
}

practitionerLeaveDelete.PATH = '/Practitioner/Leave';
